const Sidebartabs = [
  {
    key: "Trading",
    linkurl: "userdashboard",
    items: [
      {
        name: "Real account",
        value: "real_account",
        icon: `<svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fill="currentColor"
                      fill-rule="evenodd"
                      d="M7.832 1.858C8.822 1.308 10.12 1 11.5 1c1.38 0 2.678.309 3.668.858C16.123 2.388 17 3.282 17 4.5v16.11c0 1.207-.901 2.069-1.842 2.57-.984.525-2.278.82-3.658.82s-2.673-.295-3.658-.82C6.901 22.68 6 21.818 6 20.61V4.5c0-1.218.877-2.111 1.832-2.642ZM8 7.231V8.5c0 .333.171.67.77.98.622.32 1.572.52 2.73.52s2.108-.2 2.73-.52c.599-.31.77-.647.77-.98V7.231c-.966.494-2.197.769-3.5.769S8.966 7.725 8 7.231ZM15 4.5c0 .162-.13.52-.804.894-.64.355-1.59.606-2.696.606-1.105 0-2.057-.251-2.696-.606C8.13 5.019 8 4.662 8 4.5c0-.162.13-.52.804-.894C9.444 3.251 10.394 3 11.5 3c1.105 0 2.057.251 2.696.606.674.375.804.732.804.894Zm0 6.83c-.982.466-2.222.67-3.5.67s-2.518-.204-3.5-.67v1.17c0 .333.171.67.77.98.622.32 1.572.52 2.73.52s2.108-.2 2.73-.52c.599-.31.77-.647.77-.98v-1.17Zm0 4c-.982.466-2.222.67-3.5.67s-2.518-.204-3.5-.67v1.17c0 .333.171.67.77.98.622.32 1.572.52 2.73.52s2.108-.2 2.73-.52c.599-.31.77-.647.77-.98v-1.17Zm0 4c-.982.466-2.222.67-3.5.67s-2.518-.204-3.5-.67v1.28c0 .108.099.441.783.806.64.341 1.597.584 2.717.584s2.076-.243 2.717-.584c.684-.365.783-.698.783-.805V19.33Z"
                      clip-rule="evenodd"
                    ></path>
                    <path
                      fill="currentColor"
                      d="M16.584 21.951c.416.049.4.049.916.049 1.38 0 2.674-.295 3.658-.82.941-.501 1.842-1.363 1.842-2.57V14.5c0-1.218-.877-2.111-1.832-2.642-.99-.55-2.288-.858-3.668-.858-.515 0-.02-.082-.5 0v2c.45-.104-.044 0 .5 0 1.105 0 2.057.251 2.696.606.674.374.804.732.804.894 0 .162-.13.52-.804.894-.64.355-1.59.606-2.696.606-.544 0-.05.104-.5 0v2h.5c1.303 0 2.534-.275 3.5-.769v1.38c0 .107-.099.44-.783.805-.64.341-1.597.584-2.717.584H17l-.416 1.951ZM6 6.014A9.163 9.163 0 0 0 5.5 6c-1.38 0-2.679.309-3.668.858C.877 7.388 0 8.282 0 9.5c0 .104.006.206.019.306A1.005 1.005 0 0 0 0 10v7.61c0 1.207.901 2.069 1.842 2.57.985.525 2.278.82 3.658.82.168 0 .335-.004.5-.013v-2.003c-.163.01-.33.016-.5.016-1.12 0-2.077-.243-2.717-.584C2.099 18.05 2 17.718 2 17.61v-1.508c.966.573 2.193.897 3.5.897.168 0 .335-.005.5-.016V14.98a5.83 5.83 0 0 1-.5.021c-1.08 0-2.005-.293-2.631-.712C2.236 13.864 2 13.388 2 13v-.769c.966.494 2.197.769 3.5.769.168 0 .335-.005.5-.014v-2.003a7.43 7.43 0 0 1-.5.017c-1.105 0-2.057-.251-2.696-.606C2.13 10.02 2 9.662 2 9.5c0-.162.13-.52.804-.894C3.444 8.251 4.394 8 5.5 8c.17 0 .337.006.5.017V6.014Z"
                    ></path>
                  </svg>`,
      },
      {
        name: "Demo account",
        value: "demo_account",
        icon: `<svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fill="currentColor"
                      fill-rule="evenodd"
                      d="M12.034 3.115a1 1 0 0 1 .932 0l10.5 5.526a1 1 0 0 1 0 1.77l-3.887 2.046v5.47a1 1 0 0 1-.18.572l-.006.009.006-.008h-.001l-.002.003-.003.005-.01.012a2.324 2.324 0 0 1-.115.15 5.772 5.772 0 0 1-.324.365c-.282.292-.7.672-1.263 1.05-1.135.758-2.846 1.494-5.186 1.494s-4.05-.736-5.182-1.495a7.671 7.671 0 0 1-1.26-1.05 5.74 5.74 0 0 1-.438-.516l-.01-.012-.003-.006-.001-.002H5.6s.006.008.002.002l-.003-.003a1 1 0 0 1-.178-.57v-5.47L3 11.183v2.764a1 1 0 1 1-2 0v-4.42a1 1 0 0 1 .534-.886l10.5-5.526ZM4.988 9.084a.5.5 0 0 0 0 .885l7.28 3.831a.5.5 0 0 0 .465 0l7.28-3.831a.5.5 0 0 0 0-.885l-7.28-3.831a.5.5 0 0 0-.466 0l-7.28 3.83ZM7.42 13.51v4.059l.075.08c.197.204.504.487.93.773.847.567 2.174 1.157 4.07 1.157 1.894 0 3.224-.59 4.073-1.157a5.716 5.716 0 0 0 1.01-.855V13.51l-4.613 2.428a1 1 0 0 1-.932 0L7.421 13.51Z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>`,
      },
    ],
  },
  {
    key: "Finance",
    linkurl: "userdashboarddeposit",
    items: [
      {
        name: "Deposit",
        value: "deposit",
        icon: `  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.033 11.2917C14.683 11.6334 14.483 12.125 14.533 12.65C14.608 13.55 15.433 14.2084 16.333 14.2084H17.9163V15.2C17.9163 16.925 16.508 18.3334 14.783 18.3334H5.21634C3.49134 18.3334 2.08301 16.925 2.08301 15.2V9.59172C2.08301 7.86672 3.49134 6.45837 5.21634 6.45837H14.783C16.508 6.45837 17.9163 7.86672 17.9163 9.59172V10.7917H16.233C15.7663 10.7917 15.3413 10.975 15.033 11.2917Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M2.08301 10.3417V6.53342C2.08301 5.54175 2.69134 4.65838 3.61634 4.30838L10.233 1.80838C11.2663 1.41672 12.3747 2.18341 12.3747 3.29174V6.4584"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M18.7987 11.6418V13.3586C18.7987 13.8169 18.432 14.1918 17.9653 14.2085H16.332C15.432 14.2085 14.607 13.5502 14.532 12.6502C14.482 12.1252 14.682 11.6335 15.032 11.2918C15.3404 10.9752 15.7653 10.7919 16.232 10.7919H17.9653C18.432 10.8085 18.7987 11.1835 18.7987 11.6418Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M5.83301 10H11.6663"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>`,
      },
      {
        name: "Withdrawal",
        value: "withdrawal",
        icon: `  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.91406 11.4575C7.91406 12.2659 8.53907 12.9159 9.30574 12.9159H10.8724C11.5391 12.9159 12.0808 12.3492 12.0808 11.6409C12.0808 10.8825 11.7474 10.6075 11.2558 10.4325L8.7474 9.55755C8.25573 9.38255 7.9224 9.11589 7.9224 8.34922C7.9224 7.64922 8.46406 7.07422 9.13072 7.07422H10.6974C11.4641 7.07422 12.0891 7.72422 12.0891 8.53256" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10 6.25V13.75" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M18.3308 10.0013C18.3308 14.6013 14.5974 18.3347 9.99737 18.3347C5.3974 18.3347 1.66406 14.6013 1.66406 10.0013C1.66406 5.4013 5.3974 1.66797 9.99737 1.66797" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M18.3281 5.00391L18.3281 1.67058L14.9948 1.67058" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M14.1614 5.83594L18.3281 1.66928" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>`,
      },
      {
        name: "Bonus codes",
        value: "promo_codes",
        icon: ` <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.2503 10.4167C16.2503 9.26671 17.1837 8.33337 18.3337 8.33337V7.50004C18.3337 4.16671 17.5003 3.33337 14.167 3.33337H5.83366C2.50033 3.33337 1.66699 4.16671 1.66699 7.50004V7.91671C2.81699 7.91671 3.75033 8.85004 3.75033 10C3.75033 11.15 2.81699 12.0834 1.66699 12.0834V12.5C1.66699 15.8334 2.50033 16.6667 5.83366 16.6667H14.167C17.5003 16.6667 18.3337 15.8334 18.3337 12.5C17.1837 12.5 16.2503 11.5667 16.2503 10.4167Z"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M7.5 12.2916L12.5 7.29163"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M12.4951 12.2917H12.5026"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M7.4951 7.70829H7.50258"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>`,
      },
      {
        name: "Transaction history",
        value: "transaction_history",
        icon: ` <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="currentColor"
                  >
                    <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z"></path>
                  </svg>`,
      },
    ],
  },
  {
    key: "Profile",
    linkurl: "accounthistory",
    items: [
      {
        name: "Profile",
        value: "profile",
        icon: ` <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="rgba(255,255,255,1)"
                  >
                    <path d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H18C18 18.6863 15.3137 16 12 16C8.68629 16 6 18.6863 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"></path>
                  </svg>`,
      },
      {
        name: "Analytics",
        value: "analytics",
        icon: `<img
                    src="/static/media/dash-right-icon02.901503ae77448a3f2941a19dd5cc4f51.svg"
                    alt=""
                  ></img>`,
      },
      {
        name: "Trading History",
        value: "trading_history",
        icon: ` <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="currentColor"
                  >
                    <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z"></path>
                  </svg>`,
      },
    ],
  },
  {
    key: "Market",
    linkurl: "marketdashboard",
    items: [
      {
        name: "Market",
        value: "market",
        icon: `<svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.3333 7.08329C18.3333 10.075 15.9083 12.5 12.9167 12.5C12.775 12.5 12.625 12.4916 12.4833 12.4833C12.275 9.84163 10.1583 7.72495 7.51666 7.51662C7.50832 7.37495 7.5 7.22496 7.5 7.08329C7.5 4.09163 9.925 1.66663 12.9167 1.66663C15.9083 1.66663 18.3333 4.09163 18.3333 7.08329Z"
                      stroke="#0094FF"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M12.5003 12.9167C12.5003 15.9083 10.0753 18.3333 7.08366 18.3333C4.09199 18.3333 1.66699 15.9083 1.66699 12.9167C1.66699 9.925 4.09199 7.5 7.08366 7.5C7.22533 7.5 7.37532 7.50832 7.51698 7.51666C10.1586 7.72499 12.2753 9.84168 12.4837 12.4833C12.492 12.625 12.5003 12.775 12.5003 12.9167Z"
                      stroke="#0094FF"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M4.65866 1.66663H2.50033C2.04199 1.66663 1.66699 2.04163 1.66699 2.49996V4.65829C1.66699 5.39996 2.56699 5.77495 3.09199 5.24995L5.25032 3.09162C5.76698 2.56662 5.40032 1.66663 4.65866 1.66663Z"
                      stroke="#0094FF"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M15.3418 18.3333H17.5001C17.9584 18.3333 18.3334 17.9583 18.3334 17.5V15.3417C18.3334 14.6 17.4334 14.225 16.9084 14.75L14.7501 16.9083C14.2334 17.4333 14.6001 18.3333 15.3418 18.3333Z"
                      stroke="#0094FF"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>`,
      },
      {
        name: "Social rewards",
        value: "social_rewards",
        icon: ` <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_2499_3466)">
                      <path
                        d="M7.50033 7.49996H7.50866M12.5003 12.5H12.5087M13.3337 6.66663L6.66699 13.3333M7.66858 17.1674C7.9417 17.1312 8.2176 17.2053 8.43518 17.3729L9.43787 18.1423C9.76933 18.397 10.2304 18.397 10.5609 18.1423L11.6016 17.3433C11.796 17.1942 12.0414 17.1285 12.2839 17.1609L13.5857 17.3322C13.9995 17.3868 14.3986 17.1562 14.5587 16.7701L15.0596 15.5591C15.1531 15.3322 15.3328 15.1526 15.5596 15.0591L16.7706 14.5582C17.1567 14.3989 17.3872 13.9989 17.3326 13.585L17.1678 12.3305C17.1317 12.0573 17.2057 11.7814 17.3733 11.5638L18.1427 10.5611C18.3973 10.2296 18.3973 9.76848 18.1427 9.43794L17.3437 8.39723C17.1946 8.20279 17.1289 7.95742 17.1613 7.71484L17.3326 6.41302C17.3872 5.99915 17.1567 5.60008 16.7706 5.4399L15.5596 4.93899C15.3328 4.84547 15.1531 4.66585 15.0596 4.439L14.5587 3.22793C14.3995 2.84182 13.9995 2.61128 13.5857 2.6659L12.2839 2.8372C12.0414 2.87053 11.796 2.80479 11.6025 2.65664L10.5619 1.85759C10.2304 1.60297 9.76933 1.60297 9.4388 1.85759L8.39815 2.65664C8.20372 2.80479 7.95837 2.87053 7.71579 2.83905L6.41405 2.66776C6.0002 2.61313 5.60116 2.84368 5.44098 3.22978L4.94102 4.44085C4.84659 4.66677 4.66697 4.8464 4.44107 4.94084L3.23006 5.44083C2.84398 5.60101 2.61344 6.00007 2.66807 6.41395L2.83935 7.71576C2.87083 7.95835 2.80509 8.20371 2.65696 8.39723L1.85795 9.43794C1.60334 9.76941 1.60334 10.2305 1.85795 10.5611L2.65696 11.6018C2.80602 11.7962 2.87175 12.0416 2.83935 12.2842L2.66807 13.586C2.61344 13.9998 2.84398 14.3989 3.23006 14.5591L4.44107 15.06C4.6679 15.1535 4.84751 15.3331 4.94102 15.56L5.44191 16.7711C5.60116 17.1572 6.00112 17.3877 6.41498 17.3331L7.66858 17.1674ZM7.91699 7.49996C7.91699 7.73008 7.73044 7.91663 7.50033 7.91663C7.27021 7.91663 7.08366 7.73008 7.08366 7.49996C7.08366 7.26984 7.27021 7.08329 7.50033 7.08329C7.73044 7.08329 7.91699 7.26984 7.91699 7.49996ZM12.917 12.5C12.917 12.7301 12.7304 12.9166 12.5003 12.9166C12.2702 12.9166 12.0837 12.7301 12.0837 12.5C12.0837 12.2698 12.2702 12.0833 12.5003 12.0833C12.7304 12.0833 12.917 12.2698 12.917 12.5Z"
                        stroke="#646A6C"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_2499_3466">
                        <rect width="20" height="20" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>`,
      },
      {
        name: "Gifts",
        value: "gifts",
        icon: `<i class="fa-solid fa-shield-halved"></i>`,
      },
      {
        name: "Rewards History",
        value: "rewards_history",
        icon: `<svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="currentColor"
                  >
                    <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z"></path>
                  </svg>`,
      },
    ],
  },
  {
    key: "Support",
    linkurl: "supportdashboard",
    items: [
      {
        name: "My requests",
        value: "my_requests",
        icon: ` <svg
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.81509 26.87C9.71509 26.86 9.59509 26.86 9.48509 26.87C7.10509 26.79 5.21509 24.84 5.21509 22.44C5.21509 19.99 7.19509 18 9.65509 18C12.1051 18 14.0951 19.99 14.0951 22.44C14.0851 24.84 12.1951 26.79 9.81509 26.87Z"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.815 30.56C2.395 32.18 2.395 34.82 4.815 36.43C7.565 38.27 12.075 38.27 14.825 36.43C17.245 34.81 17.245 32.17 14.825 30.56C12.085 28.73 7.575 28.73 4.815 30.56Z"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M32.655 5H24.655C20.655 5 18.655 7 18.655 11V24C18.655 24.55 19.105 25 19.655 25H32.655C36.655 25 38.655 23 38.655 19V11C38.655 7 36.655 5 32.655 5Z"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M23.655 12.5H33.655"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M23.655 17.5H30.655"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>`,
      },
      {
        name: "Create request",
        value: "create_request",
        icon: `<svg
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.81509 26.87C9.71509 26.86 9.59509 26.86 9.48509 26.87C7.10509 26.79 5.21509 24.84 5.21509 22.44C5.21509 19.99 7.19509 18 9.65509 18C12.1051 18 14.0951 19.99 14.0951 22.44C14.0851 24.84 12.1951 26.79 9.81509 26.87Z"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.815 30.56C2.395 32.18 2.395 34.82 4.815 36.43C7.565 38.27 12.075 38.27 14.825 36.43C17.245 34.81 17.245 32.17 14.825 30.56C12.085 28.73 7.575 28.73 4.815 30.56Z"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M32.655 5H24.655C20.655 5 18.655 7 18.655 11V24C18.655 24.55 19.105 25 19.655 25H32.655C36.655 25 38.655 23 38.655 19V11C38.655 7 36.655 5 32.655 5Z"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M25.155 15H32.155"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M28.655 18.5V11.5"
                      stroke="#292D32"
                      stroke-width="1.5"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>`,
      },
      {
        name: "FAQ",
        value: "faq",
        icon: `<svg
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_3228_1365)">
                      <path
                        d="M17.48 16.5067C17.9066 16.0534 18.4 15.6934 18.9733 15.4667C19.5333 15.2401 20.16 15.1467 20.7733 15.1867C21.4 15.2401 21.9867 15.4134 22.52 15.7201C23.0534 16.0267 23.5067 16.4667 23.84 16.9734C24.1733 17.4934 24.4 18.0667 24.4933 18.6934C24.56 19.2934 24.52 19.9334 24.32 20.5067C24.1467 21.0801 23.8133 21.6401 23.3867 22.0534C22.9467 22.4934 22.4267 22.8267 21.84 23.0401"
                        stroke="#292D32"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M27.6667 9H14.3333C11.3878 9 9 11.3878 9 14.3333V27.6667C9 30.6122 11.3878 33 14.3333 33H27.6667C30.6122 33 33 30.6122 33 27.6667V14.3333C33 11.3878 30.6122 9 27.6667 9Z"
                        stroke="#292D32"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21 27H21.0133"
                        stroke="#292D32"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3228_1365">
                        <rect
                          width="32"
                          height="32"
                          fill="white"
                          transform="translate(5 5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>`,
      },
    ],
  },
];

export default Sidebartabs;
